import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Lazy, Pagination, Autoplay } from 'swiper/core';
import styled from 'styled-components';
import GetImage from '../utils/GetImage';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Autoplay, Lazy, Pagination]);

const GalleryWrapper = styled.div`
  margin-bottom: 2rem;

  .title {
    text-align: center;
    margin-bottom: 40px;
  }

  img {
    aspect-ratio: 16 / 9;
    width: 100%;
    height: auto;
  }
  
  .swiper-slide {
    position: relative;
    padding-top: 56.25%;  /* For an aspect ratio of 16:9; adjust for your aspect ratio */
  }
  
  .swiper-slide img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default function Gallery({ images, displayCaptions }) {
  return (
    <GalleryWrapper>
      <Swiper
        spaceBetween={30}
        centeredSlides
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        style={{
          '--swiper-navigation-color': '#0032a0',
          '--swiper-pagination-color': '#0032a0',
          '--swiper-navigation-size': '80px',
        }}
        lazy
        loop
        pagination={{
          clickable: true,
        }}
      >
        {images.map((image) => (
          <SwiperSlide key={image._key}>
            <img
              data-src={GetImage(image.image.asset, true)}
              alt={image.caption}
              className="swiper-lazy"
            />
            <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />
            {displayCaptions ? (
              <div className="title" data-swiper-parallax="-100">
                {image.caption}
              </div>
            ) : (
              ''
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </GalleryWrapper>
  );
}
